<section class="viz-card" *ngIf="hasVisualContent()">
  <div class="viz-header">
    <div class="viz-title">Visualization Agent</div>
    <div class="viz-meta">
      <span class="pill" *ngIf="charts.length">View: Chart</span>
      <span class="pill" *ngIf="!charts.length">View: Table</span>
      <span class="pill pill--rows" *ngIf="rowCount > 0">{{ rowCount }} {{ rowCount === 1 ? 'record' : 'records' }}</span>
    </div>
  </div>

  <p class="viz-reasoning" *ngIf="visualization?.reasoning">{{ visualization?.reasoning }}</p>

  <div class="viz-source" *ngIf="visualization?.metadata?.sourceTables?.length">
    Source: {{ visualization?.metadata?.sourceTables?.join(', ') }}
  </div>

  <div class="charts" *ngIf="charts.length">
    <div 
      class="chart-panel" 
      *ngFor="let chart of charts; let i = index; trackBy: trackByIndex"
      [class.fullscreen]="fullscreenChartIndex === i"
    >
      <div class="chart-toolbar">
        <button (click)="toggleFullScreen(i)" title="Fullscreen">⛶</button>
        <button (click)="resetZoom(i)" title="Reset Zoom">⟲</button>
        <button (click)="downloadChart(i)" title="Download">⬇️</button>
      </div>

      <div class="chart-title">
        {{ chart.title || ('Chart ' + (i + 1)) }}
      </div>

      <div class="chart-desc" *ngIf="chart.description">
        {{ chart.description }}
      </div>

      <div class="echarts-host" #chartHost></div>
    </div>
  </div>

  <div class="viz-no-data" *ngIf="!hasReport() && !charts.length">
    No tabular data available for this query.
  </div>

  <div class="report" *ngIf="hasReport()">
    <div class="report-title">{{ visualization?.report?.title || 'Report Table' }}</div>
    <ag-grid-angular
      class="report-grid"
      [theme]="theme"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [domLayout]="'autoHeight'"
      [pagination]="true"
      [paginationPageSize]="10"
      [paginationPageSizeSelector]="[10, 20, 50, 100]"
      [suppressMovableColumns]="true"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</section>
